import React from 'react';

import { Button, Form, Modal } from 'antd';
import { SimHistoryInfo } from 'domain/entities/SimulateEntity';
import { DialogIcon } from 'presentation/components/Modal/DialogIcon';
import { ConfirmModalProps } from 'presentation/components/Modal/Modal.type';
import { FormInput } from 'presentation/components/form/FormInput.component';

interface props extends ConfirmModalProps {
    data?: SimHistoryInfo[];
}

export const SimInputTitleModal = ({
    open,
    type = 'info',
    icon,
    okText = '実行結果を保存',
    cancelText = '戻る',
    onCancel,
    onOk,
    returnValue,
    okButtonProps,
    cancelButtonProps,
}: props) => {
    const [form] = Form.useForm();
    const [btnDisabled, setBtnDisabled] = React.useState<boolean>(true);

    React.useEffect(() => {
        if (open) {
            form.resetFields();
            setBtnDisabled(true);
        }
    }, [open]);

    const handleOk = () => {
        const selectedValue = form.getFieldValue('title');
        if (selectedValue) {
            onOk && onOk(selectedValue);
            return;
        }
    };
    const valueChange = () => {
        form.validateFields({ validateOnly: true })
            .then(() => {
                setBtnDisabled(false);
            })
            .catch((err) => {
                setBtnDisabled(err.errorFields.length > 0);
            });
    };

    const handleCancel = () => {
        if (returnValue) {
            onCancel && onCancel(returnValue);
            return;
        }
        onCancel && onCancel();
    };

    return (
        <Modal
            width={327}
            open={open}
            footer={null}
            centered
            className="modal-info CU-059-01-container"
        >
            <Form form={form} onValuesChange={valueChange}>
                <section style={{ paddingTop: 12, paddingBottom: 4 }}>
                    <div style={{ width: '100%' }} className="center-inside">
                        <DialogIcon type={type} icon={icon} />
                    </div>
                    <div
                        className="confirm-modal-2-title text-sm"
                        style={{ marginBottom: 8, marginTop: 32 }}
                    >
                        履歴の名前を入力してください。
                    </div>
                    <div
                        className="confirm-modal-2-description"
                        style={{ marginBottom: 32, color: '' }}
                    >
                        <FormInput name="title" size={'large'} required showRequiredError={false} />
                    </div>
                    <Button
                        type="primary"
                        className="button-login-text"
                        {...okButtonProps}
                        disabled={btnDisabled}
                        style={{
                            width: '100%',
                            height: 48,
                            marginBottom: 12,
                            ...okButtonProps?.style,
                        }}
                        onClick={() => handleOk()}
                    >
                        {okText}
                    </Button>
                    <Button
                        type="link"
                        block
                        className="text-button-cancel"
                        style={{ width: '100%', height: 48 }}
                        onClick={() => handleCancel()}
                        {...cancelButtonProps}
                    >
                        {cancelText}
                    </Button>
                </section>
            </Form>
        </Modal>
    );
};
